import React from "react";

import utils from "./utils";
import classes from "./index.module.css";
import RadioButton from "../../base-components/radio-button";
import Button from "../../base-components/button";
import { setUserCurrentScreen } from "../../redux/action/app";
import { updateUserProfile } from "../../redux/thunk/app.thunk";
import config from "../../config";
import { openKyc2 } from "../../navigators/routes";
import { useDispatch, useSelector } from "react-redux";
import TextInput from "../../base-components/text-input";

const Kyc3 = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.app.isLoading);
  const [activeButton, setActiveButton] = React.useState("Employed");
  const [dataValues, setDataValues] = React.useState({
    nameOfEmployer: "",
    employerAddress: "",
    occupation: "",
  });
  const [errors, setErrors] = React.useState({
    nameOfEmployerError: false,
    employerAddressError: false,
    occupationError: false,
  });

  const onChange = (name) => (event) => {
    setDataValues({ ...dataValues, [name]: event.target.value });
  };

  const onBlur = () => {};

  const onFocus = (item) => {
    setErrors({ ...errors, [item]: false });
  };

  const onSubmit = () => {
    setErrors({
      nameOfEmployerError: showNameOfEmployerError,
      employerAddressError: showEmployerAddressError,
      occupationError: showOccupationError,
    });
    if ((activeButton === "Employed" && !showNameOfEmployerError && !showEmployerAddressError && !showOccupationError) || (activeButton !== "Employed") )
      dispatch(
        updateUserProfile({
          employmentStatus: activeButton,
          nameOfEmployer: dataValues.nameOfEmployer,
          employerAddress: dataValues.employerAddress,
          employerJobName: dataValues.occupation
        })
      ).then(() => {
        dispatch(setUserCurrentScreen(config.routes.kyc2));
        openKyc2();
      });
  };

  const showNameOfEmployerError = dataValues.nameOfEmployer.length === 0;
  const showEmployerAddressError = dataValues.employerAddress.length === 0;
  const showOccupationError = dataValues.occupation.length === 0;

  return (
    <div className={classes.Container}>
      <div className={classes.top}>
        <h2 className={classes.Heading}>{utils.KYC_3_HEADER}</h2>
        <p className={classes.SubHeading}>{utils.KYC_3_SUBHEADING}</p>
      </div>
      <div className={classes.middle}>
        {utils.RADIO_ITEMS.map((item) => {
          return (
            <RadioButton
              text={item.label}
              isActive={activeButton === item.label}
              setActive={setActiveButton}
            />
          );
        })}

        {activeButton === "Employed" && (
          <div>
            {utils.FORM_ITEMS.map((item) => {
              return (
                <div className={classes.textInput}>
                  <TextInput
                    id="example-3"
                    label={item.label}
                    placeholder={item.label}
                    onBlur={onBlur}
                    onChange={onChange(item.value)}
                    onFocus={() => onFocus(item.errorValue)}
                    showError={errors[item.errorValue]}
                    errorMessage={item.errorMessage}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className={classes.bottom}>
        <Button
          //spacing={{ top: "medium", bottom: "medium" }}
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            alignItems: "center",
          }}
          loading={isLoading}
          state={undefined}
          action={onSubmit}
        >
          {utils.KYC_3_BUTTON_HEADING}
        </Button>
      </div>
    </div>
  );
};

export default Kyc3;
